import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import {
  alliesCatalog,
  alliesList,
  allyBankAccount,
  allyDetail,
  branchOfficeDetail,
  branchOfficesPage1,
  cashoutAllyPage1,
  checkMonthlyCut,
  commercialAlliesTypeCatalog,
  commercialAllyBankAccount,
  commercialAllyPage1,
  commissionsByProductType,
  commissionsByProductTypeList,
  fiscalInfo,
  monthlyCut,
  validateMonthlyCharges
} from './data.ts'
import { isLegacyLocationMock } from '@/__mocks__/util/legacyLocation.ts'

const currentYear = new Date().getFullYear()
const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0')

export default [
  {
    method: 'GET',
    path: '/commercial-allies?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, alliesList]
    }
  },
  {
    method: 'GET',
    path: '/commercial-allies/2',
    reply: async () => {
      await wait()
      return [status.ok, allyDetail]
    }
  },
  {
    method: 'GET',
    path: '/commercial-ally-negative-balance-retention/1',
    reply: async () => {
      await wait()
      return [
        status.ok,
        { data: { allowNegativeCollection: true, totalAmount: '500' } }
      ]
    }
  },
  {
    method: 'GET',
    path: '/commercial-ally-product-types?limit=20&commercialAllyId=2',
    reply: async () => {
      await wait()
      return [status.ok, commissionsByProductTypeList]
    }
  },
  {
    method: 'GET',
    path: '/commercial-ally-product-types/2',
    reply: async () => {
      await wait()
      return [status.ok, commissionsByProductType]
    }
  },
  {
    method: 'POST',
    path: '/commercial-ally-product-types',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/commercial-ally-product-types/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/commercial-ally-product-types/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/commercial-allies/transfer-status/2',
    reply: async () => {
      await wait()
      return [
        status.ok,
        {
          data: { canTransfer: '1' }
        }
      ]
    }
  },
  {
    method: 'PUT',
    path: '/commercial-allies/transfer-status/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/commercial-allies/catalog',
    reply: async () => {
      await wait()
      return [status.ok, alliesCatalog]
    }
  },
  {
    method: 'GET',
    path: '/commercial-allies-type/catalog',
    reply: async () => {
      await wait()
      return [status.ok, commercialAlliesTypeCatalog]
    }
  },
  {
    method: 'GET',
    path: '/commercial/ally/bank/account?limit=20&commercialAllyId=2',
    reply: async () => {
      await wait()
      return [status.ok, allyBankAccount]
    }
  },
  {
    method: 'GET',
    path: '/payall/bank/account?serviceId=1',
    reply: async () => {
      await wait()
      return [status.ok, allyBankAccount]
    }
  },
  {
    method: 'GET',
    path: '/commercial-allies/send-code/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/commercial/ally/bank/account/6/set-default',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/commercial/ally/bank/account/2',
    reply: async () => {
      await wait()
      return [status.ok, commercialAllyBankAccount]
    }
  },
  {
    method: 'GET',
    path: '/commercial-ally-tax-information/2',
    reply: async () => {
      await wait()
      if (isLegacyLocationMock())
        return [
          status.ok,
          { data: { ...fiscalInfo.data, latitude: null, longitude: null } }
        ]
      return [status.ok, fiscalInfo]
    }
  },
  {
    method: 'POST',
    path: '/commercial-ally-tax-information',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/cashout/process?bank=bdv',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: `/monthly/cut/invoice_odoo?year=${currentYear}&month=${currentMonth}`,
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: `/monthly/cut/invoice_odoo/check?year=${currentYear}&month=${currentMonth}`,
    reply: async () => {
      await wait()
      return [status.ok, validateMonthlyCharges]
    }
  },
  {
    method: 'GET',
    path: '/commercial/ally/bank/account?commercialAllyId=1',
    reply: async () => {
      await wait()
      return [status.ok, commercialAllyPage1]
    }
  },
  {
    method: 'GET',
    path: '/cashout/list/pending?limit=100',
    reply: async () => {
      await wait()
      return [status.ok, cashoutAllyPage1]
    }
  },
  {
    method: 'POST',
    path: '/cashout/process?bank=other',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/branch-offices?limit=20&commercialAlly=2',
    reply: async () => {
      await wait()
      return [status.ok, branchOfficesPage1]
    }
  },
  {
    method: 'GET',
    path: '/branch-offices/1700',
    reply: async () => {
      await wait()
      if (isLegacyLocationMock()) return [status.ok, branchOfficeDetail]
      return [
        status.ok,
        {
          ...branchOfficeDetail,
          data: {
            ...branchOfficeDetail.data,
            address: 'Av. Principal, Caracas',
            latitude: '10.48801',
            longitude: '-66.87919'
          }
        }
      ]
    }
  },
  {
    method: 'PUT',
    path: '/branch-offices/1700',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/monthly/cut?limit=20&page=1&month=06&year=2026',
    reply: async () => {
      await wait()
      return [status.ok, monthlyCut]
    }
  },
  {
    method: 'GET',
    path: '/monthly/cut/invoice_odoo/check?year=2026&month=06',
    reply: async () => {
      await wait()
      return [status.ok, checkMonthlyCut]
    }
  }
]
